<template>
  <div class="user-avatar">
    <div class="user-avatar__box">
      <div class="button-group">
        <button
          v-if="preview"
          v-tippy="{
            arrow : true,
            arrowType : 'sharp',
            placement : 'top',
            animation : 'shift-away'
          }"
          type="button"
          content="Clear"
          class="button button--color-c"
          @click.stop.prevent="cancelCrop"
        >
          <i class="icon icon-e-remove" />
        </button>
        <button
          v-if="preview"
          v-tippy="{
            arrow : true,
            arrowType : 'sharp',
            placement : 'top',
            animation : 'shift-away'
          }"
          type="button"
          content="Confirm"
          class="button"
          @click.stop.prevent="cropImage"
        >
          <i class="icon icon-check" />
        </button>
      </div>

      <img
        v-if="preview"
        id="avatar-preview"
        :src="preview"
      >

      <div
        v-if="!preview"
        class="avatar avatar--circle"
      >
        <img :src="model" alt="">
      </div>
    </div>

    <input
      id="avatar-selection"
      type="file"
      style="display: none"
      @change="fileChange"
    >

    <div class="user-avatar__toolbar">
      <div class="button-group">
        <button
          type="button"
          class="button u-br"
        >
          <span class="button__icon">
            <i class="icon icon-link" />
          </span>
          <span class="button__label">Use image links</span>
        </button>
        <button
          type="button"
          class="button u-br"
          @click.stop.prevent="selectFile"
        >
          <span class="button__icon">
            <i class="icon icon-move-up-2" />
          </span>
          <span class="button__label">Upload a photo</span>
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import Cropper from 'cropperjs'

export default {
  props: {
    value: [File, String],
  },
  data () {
    return {
      model: null,
      cropper: null,
      preview: null,
    }
  },
  watch: {
    value (avatar) {
      if (!(avatar instanceof File)) {
        this.model = avatar
      }
    },
  },
  methods: {
    cancelCrop () {
      this.cropper.destroy()

      this.$nextTick(() => {
        this.model = this.value
        this.preview = null
      })
    },

    cropImage () {
      this.cropper.getCroppedCanvas().toBlob(blob => {
        var url = URL.createObjectURL(blob)

        this.cropper.destroy()

        this.model = url
        this.preview = null

        this.$emit('input', new File([blob], 'name'))
      })
    },

    readImageAsDataURL (image) {
      return new Promise((resolve, reject) => {
        if (image) {
          return resolve(URL.createObjectURL(image))
        }

        return reject(new Error('No file specified'))
      })
    },

    isImage (image) {
      return ['image/jpg', 'image/jpeg', 'image/png', 'image/gif', 'image/bmp'].includes(image.type)
    },

    async fileChange (e) {
      const file = e.target.files[0]

      this.preview = await this.readImageAsDataURL(file)

      this.$nextTick(() => {
        this.cropper = new Cropper(document.getElementById('avatar-preview'), {
          aspectRatio: 1,
          viewMode: 2,
          autoCropArea: 0.9,
          zoomOnWheel: true,
          guides: true,
          movable: false,
          rotatable: false,
        })
      })
    },

    selectFile () {
      document.getElementById('avatar-selection').click()
    },
  },
}
</script>
